import React from "react";
import PageTitle from "../components/PageTitle";
import LoginForm from "../components/forms/LoginForm";
import { connect } from "react-redux";
import { logout, login } from "../actions/auth";
import componentWithLoadTrigger from "sc/ui/components/hoc/componentWithLoadTrigger";
import { uiErrorSelector } from "../../../../selectors/ui";
import { clearUIError } from "../../../../actions/ui/ui-error";

export default connect(
  (state, ownProps) => ({
    backendError: uiErrorSelector(state),
  }),
  (dispatch, ownProps) => ({
    onLogin: formData => {
      dispatch(clearUIError());
      dispatch(login(formData.username, formData.password));
    },
    onLoad: () => dispatch(logout()),
  }),
)(
  componentWithLoadTrigger(
    class extends React.Component {
      constructor(props) {
        super(props);
        this.state = { isLoggingIn: false };
        this.onLogin = this.onLogin.bind(this);
      }

      onLogin(formData) {
        this.setState({ isLoggingIn: true });
        this.props.onLogin(formData);
      }

      componentWillReceiveProps(nextProps) {
        if (nextProps.backendError !== "") {
          this.setState({ isLoggingIn: false });
        }
      }

      render() {
        return (
          <div id="login-page">
            <PageTitle title="Login" />
            <div className="login-form">
              <LoginForm
                onLogin={this.onLogin}
                backendError={this.props.backendError}
                disabled={this.state.isLoggingIn}
              />
            </div>
          </div>
        );
      }
    },
  ),
);



// WEBPACK FOOTER //
// ./src/sc/ui/sites/oncall/pages/LoginPage.js